// PART 1: pure client-side pre-validation for the rename form, mirroring
// server/src/util/validate.ts's `validateName` length gate (trim; 1-32
// VISIBLE chars checked against the TRIMMED string) so the common case
// never round-trips a rejection. Deliberately does NOT replicate the
// server's profanity screen -- the server remains the sole authority for
// that (and for the final trim actually stored); this only pre-empts the
// obvious client-detectable cases (empty/whitespace-only, oversized) so a
// user gets instant feedback instead of a network round-trip for those.

export const MAX_NAME_LEN = 32;

/** True iff `draft`, once trimmed, is 1-32 visible characters -- the exact
 * bound `validateName` enforces server-side. Pure, so it's testable without
 * mounting the Lobby form. */
export function isValidRenameDraft(draft: string): boolean {
  const trimmed = draft.trim();
  return trimmed.length >= 1 && trimmed.length <= MAX_NAME_LEN;
}
